<div class="fc-header-wrapper">
  @if (headerEnabled && headerText) {
     <a href="/"><div [innerHTML]="headerHtml" ></div></a>
  }
</div>
<hr class="fc-header-divider">
